export const StopIcon = () => (
	<svg width="61" height="60" viewBox="0 0 61 60" fill="none" xmlns="http://www.w3.org/2000/svg">
		<circle cx="30.5" cy="30" r="29.5" fill="white" stroke="#FF433E" />
		<rect
			x="19.7109"
			y="19.2111"
			width="21.5779"
			height="21.5779"
			rx="4"
			fill="#FFE8E8"
			stroke="#FF433E"
			strokeWidth="4"
		/>
	</svg>
);
